import React from "react";
import styles from "../component/custom.module.css";
import Images from "./Images";

function scrollToForm() {
  // Get the target div element
  const targetDiv = document.getElementById("registerFrm");
  // Add an event listener to the button
      // Scroll to the target div with smooth behavior
      targetDiv.scrollIntoView({ behavior: "smooth" });
}

function Nav({ executeScroll }) {  
  return (    
    <div className={styles.navheader}>
      <div className="container-fluid">
        <nav className="navbar">
          <div className={styles.logo}>
            <img src={Images.LogoHeaderV3} alt="SOYF" />
          </div>
          <a
            className={styles.manu}
            href="https://www.moha.co.in"
            target="_blank"
            rel="noreferrer"
          >
            Visit Website
          </a>
          <button
            href="#"
            data-event-id="register"
            className={[styles.commonBtn, 'btn-link'].join(' ')}
            onClick={scrollToForm}
          >
            register now
          </button>
        </nav>
      </div>
    </div>
  );
}

export default Nav;
